import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from './services/api/api.service';
import { ErrorService } from './services/error/error.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptor } from './services/api/api.interceptor';
import { AuthService } from './services/auth/auth.service';
import { AuthGuard } from './guards/auth.guard';
import { UserStateService } from './services/user/user-state.service';
import { CookieService } from 'ngx-cookie-service';
import { CommunicationService } from './services/communication.service';
import { UsersApiService } from './services/api/users-api.service';
import { ClientsApiService } from './services/api/clients-api.service';
import { ServicesApiService } from './services/api/services-api.service';
import { FilesApiService } from './services/api/files-api.service';
import { FileFilterService } from './services/files-filter.service';
import { HearingsApiService } from './services/api/hearings-api.service';
import { LawyersApiService } from './services/api/lawyers-api.service';
import { NewFileService } from './services/new-file.service';
import { OpponentsApiService } from './services/api/opponents-api.service';
import { MarineApiService } from './services/api/marine-api.service';
import { CourtsApiService } from './services/api/courts-api.service';
import { DocumentsApiService } from './services/api/documents-api.service';
import { ChatApiService } from './services/api/chat-api.service';
import { EventsApiService } from './services/api/events-api.service';
import { WebsocketService } from './services/websocket.service';
import { DashboardApiService } from './services/api/dashboard-api.service';
import { DataEntryGuard } from './guards/data-entry.guard';
import { LawyerGuard } from './guards/lawyer.guard';
import { NotificationService } from './services/notifications.service';
import { NotificationsApiService } from './services/api/notifications-api.service';
import { PrintService } from './services/print.service';
import { InvoicesApiService } from './services/api/invoices-api.service';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule
  ],
  providers: [
    ApiService,
    UsersApiService,
    ClientsApiService,
    ServicesApiService,
    FilesApiService,
    HearingsApiService,
    LawyersApiService,
    OpponentsApiService,
    MarineApiService,
    CourtsApiService,
    DocumentsApiService,
    ServicesApiService,
    ChatApiService,
    EventsApiService,
    InvoicesApiService,
    ErrorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    AuthService,
    UserStateService,
    AuthGuard,
    CookieService,
    { provide: 'COOKIES', useValue: '' }, // only used in server, inject placeholder here for browser
    CommunicationService,
    FileFilterService,
    NewFileService,
    WebsocketService,
    DashboardApiService,
    NotificationService,
    NotificationsApiService,
    DataEntryGuard,
    LawyerGuard,
    PrintService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}
